require("./index.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onInput: function ({target}) {
        this.setState({ dismissed: !target });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/FeedHelp/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Helps_template = require("./components/Helps.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Helps_tag = marko_loadTag(Helps_template),
    Feedbacks_template = require("./components/Feedbacks.marko"),
    Feedbacks_tag = marko_loadTag(Feedbacks_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "position-relative bottom-0 w-100 px-3",
        style: "height:8vh"
      },
    marko_attrs1 = {
        "class": "btn btn-primary float-right"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("7ce645"),
    marko_node0 = marko_createElement("ul", {
        "class": "list-inline"
      }, "7", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("li", {
          "class": "pr-4"
        }, null, null, 1)
        .e("a", {
            href: "https://www.multipple.com"
          }, null, null, 1)
          .e("span", {
              "class": "text-muted"
            }, null, null, 1)
            .t("Documentation")
      .e("li", null, null, null, 1)
        .e("a", {
            href: "https://www.multipple.com/contacts"
          }, null, null, 1)
          .e("span", {
              "class": "text-muted"
            }, null, null, 1)
            .t("Contact Support");

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "col-4",
      qs: "col-5",
      hs: "col-8",
      class: "FHBlock position-absolute zindex-2 right-0 top-0 theme-bg " + (!state.dismissed ? "active shadow-lg" : ""),
      renderBody: function(out) {
        AutoScroll_tag({
            height: "92vh",
            class: "p-3",
            renderBody: function(out) {
              if (input.target == "help") {
                Helps_tag({}, out, __component, "2");
              } else if (input.target == "feedback") {
                Feedbacks_tag({}, out, __component, "3");
              } else {}
            }
          }, out, __component, "1");

        out.be("div", marko_attrs0, "4", component);

        out.be("button", marko_attrs1, "5", component, null, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        Locale_tag({
            text: "Close"
          }, out, __component, "6");

        out.ee();

        out.n(marko_node0, component);

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
